import React, { useState } from 'react';
import AudioEqualizer from './AudioEqualizer';
import { LESSON_STATE } from '../../constants/video-js-constants';

const AccordionItem = ({ item, isOpen, onClick, onLessonClick, plainList }) => {
    return (
      <div className="keduall-custom-accordion-item">
        <div
          onClick={onClick}
          className="keduall-custom-accordion-header flex p-4 justify-content-between align-items-center align-self-stretch"
        >
          <h3 className={`keduall-custom-accordion-title keduall-typography text-16-medium-500 ${isOpen ? 'keduall-custom-accordion-title-active' : ''}`}>
            {item.title}
          </h3>
          <i className={`pi keduall-custom-accordion-icon ${isOpen ? 'pi-chevron-down' : 'pi-chevron-up'}`}></i>
        </div>
  
        {isOpen && (
          <div className={`keduall-custom-accordion-content open px-5 pb-4`}>
            <ul className="keduall-custom-accordion-list list-none p-0 m-0 flex flex-column gap-3">
              {plainList
                ? item.content.map((lesson, index) => (
                    <li
                      key={index}
                      className="keduall-custom-accordion-list-item keduall-custom-accordion-list-item--plain flex align-items-start keduall-typography text-14-normal-400 text-default-txt"
                    >
                      <span className="keduall-custom-accordion-lesson-number mr-1">{index + 1}.</span>
                      <span className="keduall-custom-accordion-lesson-text">{lesson.lesson}</span>
                    </li>
                  ))
                : item.content.map((lesson, index) => {
                const getIcon = () => {
                  switch (lesson.state) {
                    case LESSON_STATE.LOADING:
                      return <i className="pi pi-spin pi-spinner keduall-custom-accordion-play-icon"></i>;
                    case LESSON_STATE.PLAYING:
                      return <AudioEqualizer />;
                    default:
                      return <i className="pi pi-play keduall-custom-accordion-play-icon"></i>;
                  }
                };

                const isPlaying = lesson.state === LESSON_STATE.PLAYING;
                const isSelected = lesson.state === LESSON_STATE.SELECTED || lesson.state === LESSON_STATE.PLAYING;

                return (
                  <li 
                    key={index} 
                    className={`keduall-custom-accordion-list-item flex justify-content-between align-items-center ${isPlaying ? 'keduall-custom-accordion-list-item-playing' : ''} ${isSelected ? 'keduall-custom-accordion-list-item-selected' : ''}`}
                    onClick={() => onLessonClick(lesson)}
                  >
                    <div className="keduall-custom-accordion-list-item-content flex align-items-center gap-2 keduall-typography text-14-medium-500 text-default-txt">
                      {getIcon()}
                      <span className="keduall-custom-accordion-lesson-number">{index + 1}.</span>
                      <span className="keduall-custom-accordion-lesson-text">{lesson.lesson}</span>
                    </div>
                    <span className="keduall-custom-accordion-time text-sm">{lesson.time}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    );
  };
  
const Accordion = ({ items, onLessonClick, initialOpenIndex = 0, openIndex: externalOpenIndex, onAccordionToggle, plainList }) => {
    const [internalOpenIndex, setInternalOpenIndex] = useState(initialOpenIndex);
    
    const openIndex = externalOpenIndex !== undefined ? externalOpenIndex : internalOpenIndex;

    const handleItemClick = (index) => {
        const newIndex = openIndex === index ? null : index;
        if (externalOpenIndex !== undefined && onAccordionToggle) {
            onAccordionToggle({ type: 'accordion-toggle', index: newIndex });
        } else {
            setInternalOpenIndex(newIndex);
        }
    };

    const handleLessonClick = (lesson) => {
        if (onLessonClick) {
            onLessonClick(lesson);
        }
    };

    return (
        <div className="keduall-custom-accordion overflow-hidden">
            {items.map((item, index) => (
                <AccordionItem
                    key={index}
                    item={item}
                    isOpen={openIndex === index}
                    onClick={() => handleItemClick(index)}
                    onLessonClick={handleLessonClick}
                    plainList={plainList}
                />
            ))}
        </div>
    );
};

export default Accordion;
  
  